import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { RouterModule } from '@angular/router';
import { Routes } from './router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { V2Component } from './v2.component';

import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ComplianceCentralComponent } from './views/compliance-central/compliance-central.component';
import { UpdateComponent } from './views/update/update.component';
import { EntityDirectoryComponent } from './views/entity-directory/entity-directory.component';
import { GlobalGuideComponent } from './views/global-guide/global-guide.component';
import { LeftSidebarComponent } from './components/left-sidebar/left-sidebar.component';
import { DatatableComponent } from './components/datatable/datatable.component';
import { ProfileIconComponent } from './components/profile-icon/profile-icon.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';

import { SharedModule } from '../shared/shared.module';
import { ModalModule } from '../shared/modules/modal/modal.module';
// import { initializeApp } from '../app.module';

import { AppService } from './services/app/app.service';
import { AuthService } from './services/auth/auth.service';
import { SessionService } from './services/session/session.service';
import { ComplianceCentralService } from './views/compliance-central/compliance-central.service';
import { ContainerService } from './services/container/container.service';
import { EntityDirectoryService } from './views/entity-directory/entity-directory.service';
import { EntitiesService } from '../shared/services';
import { ItemOptionsComponent } from './components/item-options/item-options.component';
import { ComplianceCentralDetailComponent } from './views/compliance-central/components/detail/detail.component';
import { RepositoryItemComponent } from './components/repository-item/repository-item.component';
import { EntityTransactionsComponent } from './views/entity-directory/components/transactions/transactions.component';
import { EntityRepositoryComponent } from './views/entity-directory/components/repository/repository.component';
import { EntityDashboardComponent } from './views/entity-directory/components/dashboard/dashboard.component';
import { EntityDetailComponent } from './views/entity-directory/components/detail/detail.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { GlobalGuideDetailComponent } from './views/global-guide/components/detail/detail.component';
import { CountryOverlayComponent } from './views/global-guide/components/overlay/overlay.component';
import { MetricCircleComponent } from './components/metric-circle/metric-circle.component';
import { SearchComponent } from './components/search/search.component';
import { ViewSwitcherComponent } from './components/view-switcher/view-switcher.component';
import { EntityHierarchyComponent } from './views/entity-directory/components/hierarchy/hierarchy.component';
import { MetricBarComponent } from './components/metric-bar/metric-bar.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { IconComponent } from './components/icon/icon.component';
import { IconService } from './components/icon/icon.service';
import { DashboardChartComponent } from './components/dashboard-chart/dashboard-chart.component';
import { OrgChartComponent } from './components/org-chart/org-chart.component';
import { MapComponent } from './views/global-guide/components/map/map.component';
import { GlobalGuideService } from './views/global-guide/global-guide.service';
import { ZoomButtonsComponent } from './components/zoom-buttons/zoom-buttons.component';

@NgModule({
  declarations: [
    SearchComponent,
    DropdownComponent,
    ItemOptionsComponent,
    DatatableComponent,
    PageHeaderComponent,
    ViewSwitcherComponent,
    LeftSidebarComponent,
    ProfileIconComponent,
    RepositoryItemComponent,
    EntityTransactionsComponent,
    EntityRepositoryComponent,
    EntityDashboardComponent,
    CountryOverlayComponent,
    MetricCircleComponent,
    EntityHierarchyComponent,
    GlobalGuideDetailComponent,
    EntityDetailComponent,
    ComplianceCentralDetailComponent,
    ComplianceCentralComponent,
    UpdateComponent,
    EntityDirectoryComponent,
    GlobalGuideComponent,
    V2Component,
    MetricBarComponent,
    IconComponent,
    DashboardChartComponent,
    OrgChartComponent,
    MapComponent,
    ZoomButtonsComponent
  ],
  exports: [
    SearchComponent,
    DropdownComponent,
    ItemOptionsComponent,
    DatatableComponent,
    PageHeaderComponent,
    ViewSwitcherComponent,
    LeftSidebarComponent,
    ProfileIconComponent,
    RepositoryItemComponent,
    EntityTransactionsComponent,
    EntityRepositoryComponent,
    EntityDashboardComponent,
    CountryOverlayComponent,
    MetricCircleComponent,
    EntityHierarchyComponent,
    GlobalGuideDetailComponent,
    EntityDetailComponent,
    ComplianceCentralDetailComponent,
    ComplianceCentralComponent,
    UpdateComponent,
    EntityDirectoryComponent,
    GlobalGuideComponent,
    V2Component
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    NgSelectModule,
    SharedModule, // TODO: Remove me when bundling with entire package?
    ModalModule, // TODO: Remove me when bundling with entire package?
    RouterModule.forChild(Routes),
    FormsModule,
    ProgressbarModule.forRoot(),
    TabsModule.forRoot(),
    TranslateModule.forChild(),
    ReactiveFormsModule
  ],
  providers: [
    AppService,
    AuthService,
    GlobalGuideService,
    ContainerService,
    ComplianceCentralService,
    EntitiesService,
    EntityDirectoryService,
    IconService,
    SessionService
  ]
})
export class V2Module {};
